import React, { useState, useContext, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import cognitoIcon from '../Assets/cognito-icon.png';
import { AppContent } from '../context/AppContext';
import { ApiContext } from '../App';
import { MdMessage, MdSpaceDashboard } from "react-icons/md";
import { IoMdContact } from "react-icons/io";
import { IoMdBusiness } from "react-icons/io";
import { FaBriefcase } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoStatsChart } from "react-icons/io5";
import { IoMdSettings } from "react-icons/io";
import { BiLogOut } from "react-icons/bi";
import { toast } from 'react-toastify';
import { Rocket } from 'lucide-react';


const Navbar = () => {
  const { isGeneralAdmin, isAdmin, userData, notifications } = useContext(AppContent);
  const API = useContext(ApiContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Détecter si on est sur mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Fermer la sidebar quand on change de page sur mobile
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Navigation items configuration
  const navigationItems = [
    {
      to: "/app",
      icon: <MdSpaceDashboard />,
      label: "Dashboard",
      badge: null
    },
    {
      to: "/all-individuals",
      icon: <IoMdContact />,
      label: "CVthèque",
      badge: null
    },
    {
      to: "/partners",
      icon: <IoMdBusiness />,
      label: "Entreprises",
      badge: null
    },
    {
      to: "/process-rh",
      icon: <FaBriefcase />,
      label: "Recrutement",
      badge: null
    },
    {
      to: "/prospection",
      icon: <Rocket />,
      label: "Prospection",
      badge: null
    },
    {
      to: "/deals",
      icon: <i className="bi bi-currency-dollar" />,
      label: "Deals",
      badge: null
    },
    /*
    {
      to: "/todo",
      icon: <FaCheck />,
      label: "To Do List",
      badge: null
    },
    */
  
    
    {
      to: "/analytics",
      icon: <IoStatsChart />,
      label: "Analytics",
      badge: null
    },
    
  ];

      /*
    {
      to: "/messaging",
      icon: <MdMessage />,
      label: "Messaging",
      badge: null
    },
    
    {
      to: "/scraping",
      icon: <IoStatsChart />,
      label: "Data Viz",
      badge: null
    },
    */

  // Logout handler with confirmation
  const handleLogout = async () => {
    try {
      // Call logout API if available
      await API.post('/auth/logout');
    } catch (error) {
      console.log('Logout API call failed, proceeding with local logout');
    } 
      localStorage.removeItem('auth-token');
      sessionStorage.clear();
      window.location.href = '/';
  };

  const confirmLogout = () => {
    setShowLogoutConfirm(true);
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      {/* Bouton Hamburger pour mobile */}
      {isMobile && (
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="fixed top-4 left-4 z-[60] w-12 h-12 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg shadow-lg flex items-center justify-center transition-all duration-300"
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isSidebarOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      )}

      {/* Overlay pour fermer la sidebar sur mobile */}
      {isMobile && isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`group fixed top-0 left-0 h-screen bg-slate-800 text-white z-50 shadow-lg flex flex-col transition-all duration-300 ease-in-out ${
        isMobile
          ? `w-64 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`
          : 'w-16 hover:w-64'
      }`}>
        
        {/* Header with Logo */}
        <div className=" py-4 border-b border-slate-700">
          <div className="flex items-center gap-3 px-3">
            <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center">
              <img src={cognitoIcon} alt="Cognito Logo" className="w-full h-full" />
            </div>
            <h2 className={`text-xl text-white font-bold tracking-wide m-0 overflow-hidden transition-all duration-300 whitespace-nowrap ${
              isMobile ? 'max-w-xs' : 'max-w-0 group-hover:max-w-xs'
            }`}>Jobrise</h2>
          </div>
        </div>

        {/*
        {userData && (
          <div className="p-4 border-b border-slate-700 hidden group-hover:block">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center font-semibold">
                {userData.name?.charAt(0).toUpperCase() || 'U'}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white truncate">{userData.name}</p>
                <p className="text-xs text-slate-400 truncate">{userData.email}</p>
                {userData.role && (
                  <span className="inline-block px-2 py-0.5 text-xs bg-slate-700 rounded-full mt-1 capitalize">
                    {userData.role}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
        */}

        {/* Navigation */}
        <nav className="flex-grow py-4">
          <ul className="space-y-2 px-2">
            {navigationItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 text-decoration-none ${
                      isActive
                        ? 'bg-indigo-600 text-white shadow-lg'
                        : 'text-slate-300 hover:bg-slate-700 hover:text-white'
                    }`
                  }
                  title={item.label}
                >
                  <div className="flex-shrink-0 relative">
                    {typeof item.icon === 'string' ? (
                      <i className={item.icon} />
                    ) : (
                      <span className="text-lg">{item.icon}</span>
                    )}
                  </div>
                  <span className={`font-medium overflow-hidden transition-all duration-300 whitespace-nowrap ${
                    isMobile ? 'max-w-xs' : 'max-w-0 group-hover:max-w-xs'
                  }`}>{item.label}</span>
                </NavLink>
              </li>
            ))}

            {/* Admin Panel - Only for admins */}
            {isGeneralAdmin() && (
              <li>
                <NavLink
                  to="/admin"
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 text-decoration-none ${
                      isActive
                        ? 'bg-orange-600 text-white shadow-lg'
                        : 'text-slate-300 hover:bg-orange-700 hover:text-white'
                    }`
                  }
                  title="Admin Panel"
                >
                  <i className="bi bi-shield-check text-lg flex-shrink-0" />
                  <span className={`font-medium overflow-hidden transition-all duration-300 whitespace-nowrap ${
                    isMobile ? 'max-w-xs' : 'max-w-0 group-hover:max-w-xs'
                  }`}>Admin Panel</span>
                </NavLink>
              </li>
            )}
          </ul>
        </nav>

        {/* Logout Section */}
        <div className="py-4 px-3.5 border-t border-slate-700">
            <button
              id='logout-button-2'
              onClick={confirmLogout}
              className="w-full flex items-center gap-3  py-2.5 text-red-400 hover:bg-red-900/20 hover:text-red-300 rounded-lg transition-all duration-200"
              title="Logout"
            >
              <BiLogOut className="text-lg flex-shrink-0 m-0 p-0 w-6 h-6" />
              <span className={`font-medium overflow-hidden transition-all duration-300 whitespace-nowrap ${
                isMobile ? 'max-w-xs' : 'max-w-0 group-hover:max-w-xs'
              }`}>Logout</span>
            </button>
          
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-xl p-6 max-w-sm mx-4 shadow-2xl">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                <BiLogOut className="h-6 w-6 text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Confirm Logout
              </h3>
              <p className="text-sm text-gray-500 mb-6">
                Are you sure you want to log out? You'll need to sign in again to access your account.
              </p>
              <div className="flex gap-3">
                <button
                  onClick={cancelLogout}
                  className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleLogout}
                  className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-lg hover:bg-red-700 transition-colors"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
